var _path, _path2, _linearGradient, _path3, _path4, _path5, _path6, _path7, _linearGradient2, _path8, _linearGradient3, _path9, _linearGradient4, _path10, _linearGradient5, _path11, _linearGradient6, _path12, _linearGradient7, _path13, _linearGradient8, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "7.086 -169.483 1277.149 1277.149",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1138.734 931.095h.283M1139.017 931.095h-.283"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.439 7.087c57.543 0 104.627 47.083 104.627 104.626v30.331l-145.36 103.833-494.873 340.894L148.96 242.419v688.676h-37.247c-57.543 0-104.627-47.082-104.627-104.625V111.742C7.086 54.198 54.17 7.115 111.713 7.115l532.12 394.525L1179.41 7.115l.029-.028z",
    fill: "#e75a4d"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e4d7",
    d: "M148.96 242.419v688.676h989.774V245.877L643.833 586.771z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b8b7ae",
    d: "M148.96 931.095l494.873-344.324-2.24-1.586L148.96 923.527z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b7b6ad",
    d: "M1138.734 245.877l.283 685.218-495.184-344.324z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1284.066 142.044l.17 684.51c-2.494 76.082-35.461 103.238-145.219 104.514l-.283-685.219 145.36-103.833-.028.028z",
    fill: "#b2392f"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 1959.712,
    y1: 737.107,
    x2: 26066.213,
    y2: 737.107,
    gradientTransform: "matrix(.0283 0 0 -.0283 248.36 225.244)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7e4d6"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f5ed",
    d: "M111.713 7.087l532.12 394.525L1179.439 7.087z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.dd545168462ca4fad729362f5142b81d.svg";
export { ForwardRef as ReactComponent };